import React from 'react';
import { Divider, Typography } from 'antd';
import { requestform } from 'messages';
import { TicketDetail } from 'types';
import Avatar from 'components/common/avatar/Avatar';
import dayjs from 'dayjs';
import { useUser } from 'hooks';

interface ticketCreateInformation {
  requestItem: TicketDetail | null;
}

interface TransferStep {
  title: string;
  status: 'finish' | 'process' | 'wait' | 'error';
}

const RequestDetailCreateFormInformation: React.FC<ticketCreateInformation> = ({ requestItem }) => {
  const { user, isLoading } = useUser(requestItem?.receptionBy === -1 ? 0 : (requestItem?.receptionBy ?? 0));
  const { user: closeByname } = useUser(requestItem?.closedBy === -1 ? 0 : (requestItem?.closedBy ?? 0));
  const { user: createByName } = useUser(requestItem?.createdBy === -1 ? 0 : (requestItem?.createdBy ?? 0));
  const rooms = [
    'Phòng Tiếp Nhận',
    'Phòng Chức Năng 1',
    'Phòng Chức Năng 2',
    'Phòng Chức Năng 3 (Hoàn tất) Phòng Chức Năng 3 (Hoàn tất) Phòng Chức Năng 3 (Hoàn tất) Phòng Chức Năng 3 (Hoàn tất)'
  ];

  return (
    <div className='h-[calc(95vh-4rem)] w-full overflow-y-auto rounded-bl-xl border-t-2 bg-[#f5f5f7] p-6'>
      {/** --- [ THONG TIN KHOI TAO ] ---*/}
      <Typography.Text className='text-[12px]/[16px] font-semibold uppercase text-[#868D97]'>
        {requestform.createInfo}
      </Typography.Text>

      {/** --- [ MA PHIEU - KENH TIEP NHAN ] --- */}
      <section>
        <div className='mt-[5px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.requestTicketId}</Typography.Text>
          <br />
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            # {requestItem?.ticketId || ''}
          </Typography.Text>
        </div>
        <div className='space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.acceptChannel}</Typography.Text>
          <br />
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {requestItem?.channel?.channelName || ''}
          </Typography.Text>
        </div>
      </section>
      <Divider className={'my-[5px] mt-[17px] bg-[#D4D8DE]'} />

      {/** --- [ THONG TIN YEU CAU ] ---*/}
      <section>
        <div className='space-y-1'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.dateRequest}</Typography.Text>
          <br />
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {requestItem?.createdAt && dayjs(requestItem.createdAt).format('DD/MM/YYYY, HH:mm:ss')}
          </Typography.Text>
        </div>
        <div className='mt-[10px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.ticketCreator}</Typography.Text>
          <div className='flex space-x-2'>
            <Avatar name={createByName?.username ? createByName?.username : requestItem?.createdByName} size={20} />
            <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
              {createByName?.username ? createByName?.username : requestItem?.createdByName}
            </Typography.Text>
          </div>
        </div>
        <div className='space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.appointmentDate}</Typography.Text>
          <br />
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {requestItem?.appointmentDate &&
              dayjs.utc(requestItem?.appointmentDate).tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY')}
          </Typography.Text>
        </div>
      </section>
      <Divider className={'my-[5px] mt-[17px] bg-[#D4D8DE]'} />

      {/** --- [ THONG TIN DIEN LUC XU LY ] ---*/}
      <section className='mt-[15px]'>
        <Typography.Text className='text-[12px]/[16px] font-semibold uppercase text-[#868D97]'>
          {requestform.processByCMIS}
        </Typography.Text>

        <div className='space-y-2'>
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {requestItem?.organizationUnit?.name}
          </Typography.Text>
        </div>

        <div className='mt-[5px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.receptionDate}</Typography.Text>
          <br />
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {requestItem?.receptionDate && dayjs(requestItem?.receptionDate).format('DD/MM/YYYY, HH:mm:ss')}
          </Typography.Text>
        </div>

        <div className='mt-[10px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.recipient}</Typography.Text>
          <br />
          <div className='flex space-x-2'>
            {user?.fullName && <Avatar name={user?.fullName} size={20} />}
            <Typography.Text className='text-[16px]/[20px] text-[#141414]'>{user?.fullName}</Typography.Text>
          </div>
        </div>

        <div className='mt-[5px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>
            {requestform.responsibleDepartment}
          </Typography.Text>
          <br />
          <div className='flex space-x-2'>
            {requestItem?.ticketDistributions
              .filter(
                (ticketDistribution) => ticketDistribution?.isPrimary === true && ticketDistribution.isActive === 1
              )
              .map((ticketDistribution) => ticketDistribution.primaryTeamName)[0] || null}
          </div>
        </div>

        <div className='mt-[5px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>
            {requestform.collaborationDepartment}
          </Typography.Text>
          <br />
          <div className=''>
            {requestItem?.ticketDistributions &&
              requestItem?.ticketDistributions
                .filter((ticketDistribution) => !ticketDistribution.isPrimary)
                .map((ticketDistribution, index) => (
                  <div key={ticketDistribution.ticketDistributionId}>
                    {index + 1}. {ticketDistribution.collaborativeTeamName}
                  </div>
                ))}
          </div>
        </div>

        {/*** --- Collaboration History Department ---*/}
        {/* <div className='mt-[10px] space-y-2'>
            <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'> {requestform.collaborationProgress}</Typography.Text>
            <br />
            <RoomTransferFlow rooms={rooms} />
          </div> */}
      </section>
      <Divider className='mt-[10px] bg-[#D4D8DE]' />

      {requestItem?.status.code === 'HOANTAT' && (
        <div>
          <Typography.Text className='text-[12px]/[16px] font-semibold uppercase text-[#868D97]'>
            {requestform.completeTitle}
          </Typography.Text>
          <div className='mt-[10px] space-y-2'>
            <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>{requestform.completedDate}</Typography.Text>
            <br />
            <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
              {requestItem?.closedAt ? dayjs(requestItem?.closedAt).format('DD/MM/YYYY, HH:mm:ss') : ''}
            </Typography.Text>
          </div>
          <div className='mt-[10px] space-y-2'>
            <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>
              {requestform.completedPersion}
            </Typography.Text>
            <br />
            <div className='flex space-x-2'>
              <Avatar name={closeByname?.fullName} size={20} />
              <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
                {closeByname?.fullName !== null ? closeByname?.fullName : ''}
              </Typography.Text>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestDetailCreateFormInformation;
